export enum PageTypeEnum {
  SIMPLE = 1,
  MODAL = 2,
  HIDDEN = 3,
  DESCRITIVE = 5,
  SUBPAGE = 6
}
